import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { Typography } from 'antd';
import { isNil } from 'lodash-es';
import { CSSProperties, memo } from 'react';
import { useTranslate } from '@tolgee/react';
import Copy from './Copy';

export interface SkuCopyProps {
  sku: string;
  label?: string;
  /**
   * 限制文字部分的max-width
   */
  width?: string | number;
  className?: string;
  style?: CSSProperties;
  exportMode?: boolean;
}

export const Sku = styled.div`
  display: flex;
  align-items: center;
  color: #515359;
  > span {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }
`;

const Text = styled(Typography.Text)`
  color: #515359;
`;
const SkuCopy = ({ width, sku: skuString, label, exportMode = false, ...rest }: SkuCopyProps) => {
  const showSku = skuString || '-';
  const { t } = useTranslate();
  let maxWidth = `${label ? '220' : '155'}px`;
  if (!isNil(width)) {
    maxWidth = typeof width === 'string' ? width : `${width}px`;
  }
  return (
    <Sku {...rest}>
      <span
        className={css`
          max-width: ${maxWidth} !important;
          white-space: break-spaces;
          word-break: break-all;
          display: inline-block;
          width: fit-content;
        `}
      >
        <Text ellipsis={{ tooltip: showSku }}>
          {label ? `${label} ` : null}
          {showSku}
        </Text>
      </span>
      {skuString && !exportMode ? (
        <Copy
          text={skuString}
          successMessage={t('trade.copySucceed')}
          failedMessage={t('trade.copyFailed')}
          onClick={(e) => e.stopPropagation()}
        />
      ) : null}
    </Sku>
  );
};
export default memo(SkuCopy);
